export default __webpack_public_path__ + "static/desk-img-653b7468846b53b0a021d4cf6adb7ebc.png";